import { RadioFragments } from '@/apollo/fragments/radio';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { Radio } from '@/types/api';
import gql from 'graphql-tag';
import { RadioForm } from '.';

@Form({
  apollo: {
    mutation: gql`
      mutation CreateRadio($input: CreateRadioInput!) {
        createRadio(input: $input) {
          radio {
            ...Radio
          }
        }
      }
      ${RadioFragments.Radio}
    `,
    refetchQueries: ['Tracks'],
  },
})
export class CreateRadioForm extends GraphQLForm<Radio> implements RadioForm {
  @Field()
  public title = '';

  @Field()
  public description = '';

  @Field()
  public fileKey = '';

  public save() {
    return super.save({
      optimisticResponse: {
        createRadio: {
          radio: {
            id: 'optimistic-id',
            title: this.title,
            description: this.description,
            fileKey: this.fileKey,
            sortOrder: 0,
            url: '',
            __typename: 'Radio',
          },
          __typename: 'CreateRadioPayload',
        },
        __typename: 'Mutation',
      },
    });
  }
}
